module.exports = __webpack_public_path__ + "img/ru_failure_7.63f5e33a.png";